module.exports = __webpack_public_path__ + "img/why-icon-active-2.c11c97fb.svg";